import { enqueueSnackbar } from 'notistack';

export enum CommonMimeType {
    PDF = 'application/pdf',
    JSON = 'application/json',
    ZIP = 'application/zip',
    XML = 'application/xml',
    WORD = 'application/msword',
    WORDX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    EXCEL = 'application/vnd.ms-excel',
    EXCELX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    POWERPOINT = 'application/vnd.ms-powerpoint',
    POWERPOINTX = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    PNG = 'image/png',
    JPEG = 'image/jpeg',
    GIF = 'image/gif',
    WEBP = 'image/webp',
    SVG = 'image/svg+xml',
    PLAIN = 'text/plain',
    CSV = 'text/csv',
    HTML = 'text/html',
    MP4 = 'video/mp4',
    MP3 = 'audio/mpeg'
}

export const downloadBase64File = ({
    base64Data,
    fileName,
    mimeType
}: {
    base64Data: string;
    fileName: string;
    mimeType: CommonMimeType;
}) => {
    if (!base64Data || typeof base64Data !== 'string') {
        enqueueSnackbar('Respuesta inválida del servidor.', { variant: 'error' });
        return;
    }

    // Decode base64 → binary
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    const blob = new Blob([byteArray], {
        type: mimeType
    });

    // Create downloadable link
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};
